module.exports = __webpack_public_path__ + "img/022-finger.2e889cb5.png";